/*
从topic中获取基础信息
event: #{sportId}^#{categoryId}^#{tournamentId}^#{eventId}^status
marketStatus: #{sportId}^#{categoryId}^#{tournamentId}^#{eventId}^#{productId}^#{marketId}^#{marketSpecifiers}^status
outcome: #{sportId}^#{categoryId}^#{tournamentId}^#{eventId}^#{productId}^#{marketId}^#{marketSpecifiers}^odds

 */
const eventTopicKeys = ['sportId', 'categoryId', 'tournamentId', 'eventId']
const marketTopicKeys = ['sportId', 'categoryId', 'tournamentId', 'eventId', 'productId', 'marketId', 'marketSpecifiers']
// const outcomeTopicKeys = ['sportId', 'categoryId', 'tournamentId', 'eventId', 'productId', 'marketId', 'marketSpecifiers']

/**
 * 解析 topic 字符串，获取比赛相关信息
 * @param  {[type]} topic [description]
 * @param  {[type]} type  订阅类型: 1, 2, 3 . 1表示 eventStatus, 2表示 marketStatus, 3表示 marketOdds
 * @return {[type]}       [description]
 */
function parseTopicInfo(topic, type) {
  if (!topic || !type) {
    return null
  }

  const infoList = topic.split('^')
  const topicKeys = type === 1 ? eventTopicKeys : marketTopicKeys

  const ret = {}

  topicKeys.forEach((key, i) => {
    const value = infoList[i]
    ret[key] = value === '~' ? '' : value
  })

  return ret
}

export default parseTopicInfo
